//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations, mapActions } from 'vuex'
import Sidebar from './sidebar'
import Layout from '@/components/ResponsiveLayout'
import Ticket from '@/views/support/Ticket'

export default {
  components: {
    Ticket,
    Layout,
    Sidebar
  },

  watch: {
    routeId: {
      handler: function(val) {
        if (typeof val === 'undefined') {
          this.$store.commit('set', ['isSideBarOpen', true])
        } else {
          if (!this.$q.screen.gt.sm) {
            this.$store.commit('set', ['isSideBarOpen', false])
          }
        }
      },
      immediate: true
    }
  },

  computed: {
    ...mapState({
      ticketQuickViewId: state => state.service.ticketQuickViewId
    }),

    routeId() {
      return this.$route.params.id // Current site id
    }
  },

  created() {
    this.resetSidebar()
    this.set(['sidebarTags', ['Active', 'Provisioning']])
    this.CLOSE_TICKET_QUICK_VIEW()
  },

  methods: {
    ...mapMutations(['set']),
    ...mapActions(['resetSidebar']),
    ...mapMutations('service', ['CLOSE_TICKET_QUICK_VIEW'])
  }
}
